module.exports = __webpack_public_path__ + "media/images/sw_logo_horiz-6a67ff4cab96655462e25574ef9e3487.svg";